// extracted by mini-css-extract-plugin
export var statItem = "_iv-1";
export var statsRow = "_iv-0";